var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrtCoreConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 656.5 315.82",
    style: {
      enableBackground: "new 0 0 656.5 315.82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#231F20;}\t.st1{fill:#008348;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.51,183.53c-13.38,6.37-24.76,9.97-39.47,9.97c-33.77,0-57.79-23.12-57.79-55.54  c0-32.15,24.25-55.01,58.74-55.01c13.26,0,25.68,3.29,37.75,8.76c4.49-11.13,10.59-21.44,18.02-30.62  c-15.92-10.58-36.09-15.87-58.63-15.87c-62.07,0-97.51,45.18-97.51,93.55c0,46.77,31.39,92.48,94.42,92.48  c23.71,0,40.71-4.94,62.87-17.58C152.4,204.64,146.16,194.5,141.51,183.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.44,144.07c22.59-9.56,26.08-24.45,26.08-44.38c0-27.11-21.1-52.09-61.65-52.09h-80.54v26.06  c11.41,18.31,18.02,39.93,18.02,63.1c0,23.17-6.61,44.78-18.02,63.1v28.99h49.24v-73.61h14.2c26.65,0,18.85,34.82,40,73.61h48.27  C477.73,179.98,490.72,153.37,470.44,144.07z M429.65,122.01h-26.07V80.82h24.92c18.54,0,28.1,6.9,28.1,20.46  C456.59,116.7,443.26,122.01,429.65,122.01z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654.44,228.85H521.42V47.6h132.97v33.22h-83.73v38h61.78l-12.81,33.21h-48.98v43.59h83.78V228.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.4,136.72c-0.14,49.92,40.22,90.5,90.13,90.64l0.26-91.35L161.4,136.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.19,136.26c0.14-49.92-40.22-90.5-90.14-90.64l-0.26,91.35L342.19,136.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.8,36.29c-55.6,0-100.68,45.07-100.68,100.68c0,55.61,45.08,100.68,100.68,100.68  c55.6,0,100.67-45.07,100.67-100.68C352.47,81.36,307.4,36.29,251.8,36.29z M251.8,217.4c-44.42,0-80.44-36.01-80.44-80.43  c0-44.42,36.01-80.44,80.44-80.44c44.42,0,80.44,36.01,80.44,80.44C332.24,181.39,296.22,217.4,251.8,217.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.49,
    y: 2.3,
    className: "st0",
    width: 2.62,
    height: 310.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.95,
    y: 135.45,
    className: "st0",
    width: 171.33,
    height: 2.41
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrtCoreConstruction);
export default __webpack_public_path__ + "static/media/SRT_CoreConstruction.f592b51a19f78ddd4d3b5065a8cca067.svg";
export { ForwardRef as ReactComponent };